module.exports = __webpack_public_path__ + "static/media/apollohospitals.7c8e4689.svg";